import React from "react";
import { InputSwitch } from "primereact/inputswitch";
import "./style.scss";

export default function SlidingSwitch(props) {
  return <InputSwitch {...props} />;
}
